/**
 * Удаляет протокол http:// или https://
 * @param url 
 * @returns url
 */
export const urlTruncateProtocol = (url: string = '') => {
  if (url) return url.replace(RegExp('^(http|https)://'), '');

  return url ?? '';
};